import React, { useState, useEffect } from "react";
import axios from "axios";

const CourseDetails = ({ platformUrl }) => {
    const [courseDetails, setCourseDetails] = useState(null);
    const [error, setError] = useState(null);
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const courseUuid = params.get("courseUuid");

    useEffect(() => {
        if (!token || !courseUuid) {
            setError("Missing access token or course UUID. Please try again.");
            return;
        }

        const fetchCourseDetails = async () => {
            try {
                const response = await axios.get(
                    `${platformUrl}/learn/api/public/v3/courses/uuid:${courseUuid}`,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );
                setCourseDetails(response.data);
            } catch (err) {
                setError(err.message);
            }
        };

        fetchCourseDetails();
    }, [platformUrl, courseUuid, token]);

    if (error) {
        return (
            <div className="bb-container bb-error">
                <h1 className="bb-title">Error</h1>
                <p>{error}</p>
                <p>Please check your access token or course UUID and try again.</p>
            </div>
        );
    }

    if (!courseDetails) {
        return <div>Loading course details...</div>;
    }

    return (
        <div className="bb-container">
            <h1 className="bb-title">Course Details</h1>
            <table className="bb-table">
                <thead>
                <tr>
                    <th>Field</th>
                    <th>Value</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>Course Name</td>
                    <td>{courseDetails.name}</td>
                </tr>
                <tr>
                    <td>Course ID</td>
                    <td>{courseDetails.courseId}</td>
                </tr>
                <tr>
                    <td>Start Date</td>
                    <td>{courseDetails.created}</td>
                </tr>
                </tbody>
            </table>
        </div>
    );
};

export default CourseDetails;
